'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$$anon$9(evaluator$10) {
  this.Mk = null;
  this.Mk = evaluator$10;
}
export { $c_Lsamples_Validation$package$$anon$9 as $c_Lsamples_Validation$package$$anon$9 };
$p = $c_Lsamples_Validation$package$$anon$9.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$$anon$9;
/** @constructor */
function $h_Lsamples_Validation$package$$anon$9() {
}
export { $h_Lsamples_Validation$package$$anon$9 as $h_Lsamples_Validation$package$$anon$9 };
$h_Lsamples_Validation$package$$anon$9.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Mk.h();
  return (((typeof v) === "number") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Validation$package$$anon$9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$$anon$9, "samples.Validation$package$$anon$9", ({
  re: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Validation$package$$anon$9 as $d_Lsamples_Validation$package$$anon$9 };
